import React, { useMemo, useCallback, useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Toast } from 'react-vant'
import { useUserInfo } from '@/hooks'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import { APIWeb } from '@/api'
import CustomTextInput from '@/components/CustomTextInput'
import CustomButton from '@/components/CustomButton'
import { copyToClipboard } from '@/utils'


export default React.memo(function newGoogle() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { actions: userActions } = useUserInfo()
    const { state } = useLocation()
    console.log('newGoogle', state)
    // 状态管理
    const [qrCodeData, setQrCodeData] = useState<{
        qr_code_base_64?: string;
        qr_code_url?: string;
        secret?: string;
    } | null>(null)
    const [googleCode, setGoogleCode] = useState('')
    const [bindLoading, setBindLoading] = useState(false)

    // 验证码校验逻辑 - 只检查是否为数字且不为空
    const isValidCode = useMemo(() => {
        // 只要是数字且不为空即可
        const codeRegex = /^\d+$/
        return googleCode.trim() !== '' && codeRegex.test(googleCode)
    }, [googleCode])

    // 获取谷歌验证器二维码
    const fetchGoogleAuthQRCode = useCallback(async () => {
        Toast.loading(t('获取二维码中'))
        try {
            const result = await APIWeb.getGoogleAuthQRCode()
            setQrCodeData(result)
        } catch (err) {
            console.log('获取谷歌验证器二维码失败:', err)
        } finally {
            Toast.clear()
        }
    }, [t])

    // 绑定谷歌验证器
    const handleChangeGoogleAuth = useCallback(async () => {

        try {
            setBindLoading(true)
            await APIWeb.verifyNewAccountCode({
                account: qrCodeData?.secret || '',
                code: googleCode,
                verify_key: state?.verify_key || ''
            })

            Toast.success({
                message: t('修改成功'),
                onClose: () => {
                    navigate('/change-account/change-success')
                }
            })

            // 绑定成功后刷新用户信息
            userActions.refreshUserInfo()

        } catch (err: any) {
            console.log('绑定谷歌验证器失败:', err)
        } finally {
            setBindLoading(false)
        }
    }, [googleCode, qrCodeData?.secret, isValidCode, t, navigate])

    // 页面加载时获取二维码
    useEffect(() => {
        fetchGoogleAuthQRCode()
    }, [fetchGoogleAuthQRCode, t])

    const handleCopyAddress = useCallback(() => {
        copyToClipboard(qrCodeData?.secret || '')
    }, [qrCodeData?.secret])

    // 处理验证码输入，只允许数字
    const handleSecretChange = useCallback((value: string) => {
        // 只允许数字输入
        const numericValue = value.replace(/\D/g, '')
        setGoogleCode(numericValue)
    }, [])

    return (
        <PageLayout tabbarPage={true}>
            <Header
                leftChildren={<Back />}
                centerChildren={<div className="text-3.75 font-medium text-black">{t('新谷歌验证器')}</div>}
            />
            <div className="px-6 py-6">
                <div className="text-sm font-400 text-black">{t('在谷歌验器APP中扫描以下二维码或手动输入')}</div>
                <div className="text-sm font-400 text-black mt-1">{t('以下密钥以添加谷歌验证')}</div>

                <div className='flex justify-center mt-10'>
                    <div className='w-50 aspect-square bg-[#000000]/5 p-3 rounded-2xl'>
                        {qrCodeData?.qr_code_base_64 && <img className='w-full block' src={qrCodeData?.qr_code_base_64} alt={t('谷歌验证器二维码')} />}
                    </div>
                </div>
                <div className='text-sm font-400 text-black flex justify-between items-center rounded-2xl p-4 bg-[#000000]/5 mt-6'>
                    <div className='flex-1 break-all mr-1'>{qrCodeData?.secret}</div>
                    <div>
                        <CustomButton size='small' color='black' className='ml-2 rounded-full' onClick={handleCopyAddress}>
                            <span className='text-xs'>
                                {t('复制')}
                            </span>
                        </CustomButton>
                    </div>
                </div>
                <div className='mt-6'>
                    <CustomTextInput
                        placeholder={t('请输入谷歌动态验证码')}
                        value={googleCode}
                        onChangeText={handleSecretChange}
                    />
                </div>
                <div className='flex justify-center mt-10'>
                    <CustomButton
                        loading={bindLoading}
                        disabled={!isValidCode || bindLoading}
                        onClick={handleChangeGoogleAuth}
                    >
                        {t('立即验证')}
                    </CustomButton>
                </div>
            </div>

        </PageLayout>
    )
})